import * as CubiqTS from "shared/cubiq-model-multi-asset";
import * as CubiqServices from "shared/cubiq-services";
import { BfxPopupNotificationData } from "./bfx-popup-notification-data.model";
import { BfxPopupNotificationCommand } from "./bfx-popup-notification-command.enum";
import { BfxBlotterOrdersContextMenuItemAcceptanceState } from "shared/cubiq-services";
import { BFXNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationType";
import { BFXNotificationSubType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationSubType";

export class BfxPopupAcceptanceMigrationNotificationData extends BfxPopupNotificationData {
  public acceptanceState: BfxBlotterOrdersContextMenuItemAcceptanceState;

  constructor(
    private activeUser: CubiqServices.ActiveUser,
    private hasAccept: boolean,
    private hasUnrestricted: boolean,
  ) {
    super(
      BFXNotificationType.ACCEPTANCE_NEEDED,
      "icon-bfx_arrow_right",
      BFXNotificationSubType.ACCEPTANCE_MIGRATION,
    );
    this.acceptanceState = new BfxBlotterOrdersContextMenuItemAcceptanceState();
    this.acceptanceState.actionRequests = {
      accept: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
      acceptInto: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
      reject: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
    };
  }

  reInitMaps() {
    this.acceptanceState.actionRequests.accept.acceptance.clear();
    this.acceptanceState.actionRequests.accept.xfer.clear();
    this.acceptanceState.actionRequests.acceptInto.acceptance.clear();
    this.acceptanceState.actionRequests.acceptInto.xfer.clear();
    this.acceptanceState.actionRequests.reject.acceptance.clear();
    this.acceptanceState.actionRequests.reject.xfer.clear();
  }

  private addToAcceptMap(orderId: string) {
    if (!this.acceptanceState.actionRequests.accept.acceptance.has(CubiqTS.AcceptanceType.ENTRY)) {
      this.acceptanceState.actionRequests.accept.acceptance.set(CubiqTS.AcceptanceType.ENTRY, []);
    }
    this.acceptanceState.actionRequests.accept.acceptance
      .get(CubiqTS.AcceptanceType.ENTRY)
      .push(orderId);
  }
  private addToAcceptIntoMap(orderId: string) {
    if (
      !this.acceptanceState.actionRequests.acceptInto.acceptance.has(CubiqTS.AcceptanceType.ENTRY)
    ) {
      this.acceptanceState.actionRequests.acceptInto.acceptance.set(
        CubiqTS.AcceptanceType.ENTRY,
        [],
      );
    }
    this.acceptanceState.actionRequests.acceptInto.acceptance
      .get(CubiqTS.AcceptanceType.ENTRY)
      .push(orderId);
  }

  protected updateAllowableActions() {
    this.actions = [];
    this.reInitMaps();
    if (
      this.hasUnrestricted ||
      (this.activeUser.userTypeId === CubiqTS.UserType.TRADER && this.hasAccept)
    ) {
      let acceptCount: number = 0;
      let acceptIntoCount: number = 0;

      this.payload.forEach((item) => {
        if (item.as_fv_deskId !== "-1") {
          //default trader group, needs accept into
          if (
            this.hasUnrestricted ||
            (this.hasAccept && this.activeUser.tradingGroupsIds.includes(item.as_fv_deskId))
          ) {
            acceptCount++;
            this.addToAcceptMap(item.orderId);
            if (this.activeUser.userTypeId === CubiqTS.UserType.TRADER) {
              acceptIntoCount++;
              this.addToAcceptIntoMap(item.orderId);
            }
          }
        } else {
          if (this.activeUser.userTypeId === CubiqTS.UserType.TRADER) {
            acceptIntoCount++;
            this.addToAcceptIntoMap(item.orderId);
          }
        }
      });

      if (acceptCount == this.payload.length) {
        this.actions.push({
          label: "Accept",
          command: BfxPopupNotificationCommand.POPUP_DI_ACCEPT,
          icon: "",
          styleClass: "bfx-context-menu-item-enabled",
        });
      }
      if (acceptIntoCount == this.payload.length) {
        this.actions.push({
          label: "Accept Into",
          command: BfxPopupNotificationCommand.POPUP_DI_ACCEPT_INTO,
          icon: "",
          styleClass: "bfx-context-menu-item-enabled",
        });
      }
    }
  }

  destroy() {
    super.destroy();
    this.activeUser = null;
  }
}
